import { OptionDetail } from '../../types/OptionChainType';

export const filterByMinimumDiscount = (minimumDiscount: number) => (option: OptionDetail): boolean => {
    const discountedStockPrice = option.underlying_asset.price * (1 - minimumDiscount);
    return option.break_even_price  <= discountedStockPrice;
};
